// Core
import styled from 'styled-components';

// Config
import { BREAKPOINTS } from '../../config/screen';

export const LoginContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
`;

export const OptionsLoginContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;

  @media (min-width: ${BREAKPOINTS.md}px) {
    padding-top: 1rem;
    padding-bottom: 1rem;
  };

  @media (min-width: ${BREAKPOINTS.lg}px) {
    padding-top: 1.2rem;
    padding-bottom: 1rem;
  };
`;

export const FormContentContainer = styled.div`
  margin: auto;
`;

/* ************** REGISTERED TRADEMARK ******************* */

export const RegisteredTrademark = styled.sup`
  font-size: 13px;
  padding-right: 2px;
  margin-left: -2px;
`;

/* ************** PADDING BETWEEN CONTENTS ******************* */

export const Description = styled.div`
  padding: 1.5rem 0 2rem 0;

  @media (min-width: ${BREAKPOINTS.md}px) {
    padding: 0 0 2rem 0;
  };

  @media (min-width: ${BREAKPOINTS.lg}px) {
    padding: 1.5rem 0 2rem 0;
  };
`;

export const AlertContainer = styled.div`
  padding-bottom: 0.75rem;

  @media (min-width: ${BREAKPOINTS.md}px) {
    padding-bottom: 0.625rem;
  };

  @media (min-width: ${BREAKPOINTS.lg}px) {
    padding-bottom: 0.5rem;
  };
`;

export const InputEmail = styled.div`
  padding-bottom: 0.75rem;

  @media (min-width: ${BREAKPOINTS.md}px) {
    padding-bottom: 0.625rem;
  };

  @media (min-width: ${BREAKPOINTS.lg}px) {
    padding-bottom: 0.5rem;
  };
`;

export const TitleContainer = styled.div`
  padding-top: 1.5rem;

  @media (min-width: ${BREAKPOINTS.md}px) {
    padding-bottom: 2rem;
    padding-top: 0;
  };

  @media (min-width: ${BREAKPOINTS.lg}px) {
    padding-top: 0.8125rem;
    padding-bottom: 0;
  };
`;
